import React from 'react';

import LoginCreds from '../../components/loginpages/LoginCreds';
import { TSPCategory, TSPConfig } from '../types';

const aieldConfig: TSPConfig = {
  key: 'aield',
  name: 'AIELD',
  category: TSPCategory.CUSTOM,
  helpText: (
    <ol>
      <li>
        Contact your AIELD representative to obtain your Client ID and Client
        Secret credentials.
      </li>
      <li>Input the provided Client ID and Client Secret below.</li>
    </ol>
  ),
  loginComponent: (props) => (
    <LoginCreds
      onValidityChange={props.onValidityChange}
      fields={[
        { label: 'Client ID', name: 'database', type: 'text', required: true },
        {
          label: 'Client Secret',
          name: 'authorizationcode',
          type: 'password',
          required: true,
        },
      ]}
    />
  ),
};

export default aieldConfig;
